import React, { useMemo, useRef } from "react";
import { AgGridReact } from "ag-grid-react";
import {
  AllCommunityModule,
  ModuleRegistry,
} from "ag-grid-community";

ModuleRegistry.registerModules([AllCommunityModule]);

interface CustomAgGridProps {
  rowData: any[];
  columnDefs: any[];
  loading?: boolean;
  height?: string | number;
  width?: string | number;
  defaultColDef?: any;
  onGridReady?: (params: any) => void;
  onCellClicked?: (params: any) => void;
  onRowSelected?: (params: any) => void;
  rowSelection?: "single" | "multiple";
  theme?: any;
  gridOptions?: any;
}

const CustomAgGrid: React.FC<CustomAgGridProps> = ({
  rowData,
  columnDefs,
  loading = false,
  height = "100%",
  width = "100%",
  defaultColDef,
  onGridReady,
  onCellClicked,
  onRowSelected,
  rowSelection,
  theme,
  gridOptions,
}) => {
  const gridRef = useRef(null);
  
  const containerStyle = useMemo(() => ({ 
    width: typeof width === "number" ? `${width}px` : width, 
    height: typeof height === "number" ? `${height}px` : height 
  }), [width, height]);
  
  const gridStyle = useMemo(() => ({ height: "100%", width: "100%" }), []);

  return (
    <div style={containerStyle}>
      <div style={gridStyle}>
        <AgGridReact
          ref={gridRef}
          rowData={rowData}
          loading={loading}
          columnDefs={columnDefs}
          theme={theme}
          defaultColDef={defaultColDef}
          onGridReady={onGridReady}
          onCellClicked={onCellClicked}
          onRowSelected={onRowSelected}
          rowSelection={rowSelection}
          {...gridOptions}
          headerHeight={40}
          rowHeight={30}
        />
      </div>
    </div>
  );
};

export default CustomAgGrid;